module.exports = __webpack_public_path__ + "static/media/Ellipse 3.9e8787e5.svg";